import React from "react";
import "../styles/homeoriginal.scss";
import { NavLink } from "react-router-dom";
import HashLoader from "react-spinners/HashLoader";
import {useTypewriter} from "react-simple-typewriter"





export default function Homeoriginal() {

  const [text] = useTypewriter ({
    words: ['Web Developer', 'Mobileapp Developer', 'AI Developer'],
    loop: 0
  })

  const hour = new Date().getHours();

  const greetings = ["Good Morning", "Good Afternoon", "Good Evening"];
  let greetingText = "";

  if (hour < 12) {
    greetingText = greetings[0];
  } else if (hour < 18) {
    greetingText = greetings[1];
  } else {
    greetingText = greetings[2];
  }

  const [loading, setLoading] = React.useState(false); 

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);


  return loading ? (
    <HashLoader
      className="loader"
      size={150}
      color={"#0a192f"}
      loading={loading}
    />
  ) : (
    
    <div className="home-original-page-container">
      <h1 className="home-original-bg">HOME</h1>
      <div className="home-original-container-elements">
        <div className="home-original-container-intros">
          <h1 className="home-original-intro-greeting">{greetingText},</h1>
          <h1 className="home-original-name-intro">I'm Sofoniyas</h1>
          <h2 className="home-original-profission-intro">
            I'm a <span>
         {text}
              </span>  from <span>Ethiopia</span>
          </h2>
        </div>
      </div>

      {/* <div> */}
      <p className="home-original-self-introduction">
        Full-Stack Developer specializing in React, Next.js, TypeScript, and the MERN Stack, with a passion for building modern, scalable, and user-focused web applications. Experienced in developing responsive and high-performance applications using React Native, Node.js, Express.js, MongoDB, and PostgreSQL, while integrating REST APIs and GraphQL services. Proficient in creating engaging user interfaces with Tailwind CSS, Bootstrap, and Three.js, and committed to writing clean, maintainable, and efficient code. Continuously exploring new technologies and best practices to deliver innovative digital experiences across web and mobile platforms.

      </p>
      <div className="home-original-buttons">
        <NavLink style={{ textDecoration: "none" }} to="/contact">
          <button className="home-original-button-one">Contact Me</button>
        </NavLink>
        <a
          className="home-original-button-two"
          href="https://www.linkedin.com/in/sofoniyas-alemu?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BPNOnQVI1R6e9dz362NhwOA%3D%3D"
          target="blank"
        >
          Know Me Better
        </a>
      </div>
      {/* </div> */}
    </div>
  );
}
